import { T as ThemeModePreference } from './ThemeMode-DBlsP3Iq.js';

const STORAGE_KEY = 'STORM_UI_THEME_MODE';

/**
 * Retrieves the stored theme mode from localStorage
 * @returns {ThemeModePreference} The stored mode or LIGHT as default
 */
var getStoredThemeMode = () => {
  if (typeof window === 'undefined') {
    return ThemeModePreference.LIGHT;
  }
  const storedMode = localStorage.getItem(STORAGE_KEY);
  if (storedMode === ThemeModePreference.DARK) {
    return ThemeModePreference.DARK;
  }
  if (storedMode === ThemeModePreference.SYSTEM) {
    return ThemeModePreference.SYSTEM;
  }
  return ThemeModePreference.LIGHT;
};

export { getStoredThemeMode as g };
//# sourceMappingURL=getStoredThemeMode-BcdoVCmP.js.map
